export default "/build/dist/da8ae8e8ee63e837.wasm"